import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function ManualMatchSetup() {
  const navigate = useNavigate();
  const [p1Name, setP1Name] = useState('');

  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [p2Name, setP2Name] = useState('');
  const [timerDuration, setTimerDuration] = useState('30');
  const [lagWinner, setLagWinner] = useState(null); // 'player1' or 'player2'
  const [raceTo, setRaceTo] = useState('5');
  const [scoreboardOnly, setScoreboardOnly] = useState(false);

  const generateSessionId = () => {
    return Math.random().toString(36).substr(2, 9);
  };

  const handleStartMatch = () => {
    const sessionId = generateSessionId();
    navigate(`/match/${sessionId}?view=display`, {
      state: {
        p1Name: p1Name || 'Player 1',
        p2Name: p2Name || 'Player 2',
        duration: parseInt(timerDuration) || 30,
        matchFormat: parseInt(raceTo) || 5,
        lagWinner: lagWinner,
        lagWinnerConfirmed: lagWinner ? true : false,
        tableName: 'Manual Match',
        manualMatch: true,
        scoreboardOnly: scoreboardOnly,
      }
    });
  };

  const isValid = p1Name && p2Name && lagWinner;

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0f172a',
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '40px 20px',
      fontFamily: "'DM Sans', sans-serif",
    }}>
      {/* Logo and Title */}
      <img
        src="/icon.png"
        alt="Cue Clock Pro"
        style={{ width: '120px', height: '120px', borderRadius: '20px', marginBottom: '12px' }}
      />
      <h1 style={{
        fontSize: '28px',
        fontWeight: '700',
        marginBottom: '40px',
        fontFamily: "'Outfit', sans-serif",
        letterSpacing: '-0.01em',
      }}>Cue Clock Pro</h1>

      {/* Form */}
      <div style={{ width: '100%', maxWidth: '500px', display: 'flex', flexDirection: 'column', gap: '24px' }}>

        {/* Player 1 Name */}
        <div style={{ textAlign: 'center' }}>
          <label style={{ display: 'block', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
            Enter Player 1 Name
          </label>
          <input
            type="text"
            value={p1Name}
            onChange={(e) => setP1Name(e.target.value)}
            placeholder="Player 1"
            style={{
              width: '100%',
              padding: '16px',
              fontSize: '18px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: 'white',
              color: '#111',
              boxSizing: 'border-box',
            }}
          />
        </div>

        {/* Player 2 Name */}
        <div style={{ textAlign: 'center' }}>
          <label style={{ display: 'block', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
            Enter Player 2 Name
          </label>
          <input
            type="text"
            value={p2Name}
            onChange={(e) => setP2Name(e.target.value)}
            placeholder="Player 2"
            style={{
              width: '100%',
              padding: '16px',
              fontSize: '18px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: 'white',
              color: '#111',
              boxSizing: 'border-box',
            }}
          />
        </div>

        {/* Scoreboard Only Toggle */}
        <div style={{ textAlign: 'center' }}>
          <label style={{ display: 'block', fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>
            Match Mode
          </label>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
            <button
              onClick={() => setScoreboardOnly(false)}
              style={{
                flex: 1,
                padding: '14px',
                fontSize: '16px',
                fontWeight: '600',
                borderRadius: '8px',
                border: !scoreboardOnly ? '2px solid #3b82f6' : '2px solid #374151',
                backgroundColor: !scoreboardOnly ? '#3b82f6' : 'white',
                color: !scoreboardOnly ? 'white' : '#111',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              ⏱️ Shot Clock
            </button>
            <button
              onClick={() => setScoreboardOnly(true)}
              style={{
                flex: 1,
                padding: '14px',
                fontSize: '16px',
                fontWeight: '600',
                borderRadius: '8px',
                border: scoreboardOnly ? '2px solid #3b82f6' : '2px solid #374151',
                backgroundColor: scoreboardOnly ? '#3b82f6' : 'white',
                color: scoreboardOnly ? 'white' : '#111',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              📊 Scoreboard Only
            </button>
          </div>
        </div>

        {/* Timer Duration - Only show if not scoreboard only */}
        {!scoreboardOnly && (
        <div style={{ textAlign: 'center' }}>
          <label style={{ display: 'block', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
            Default Timer Settings (seconds)
          </label>
          <input
            type="number"
            value={timerDuration}
            onChange={(e) => setTimerDuration(e.target.value)}
            placeholder="30"
            style={{
              width: '100%',
              padding: '16px',
              fontSize: '18px',
              borderRadius: '8px',
              border: 'none',
              backgroundColor: 'white',
              color: '#111',
              boxSizing: 'border-box',
            }}
          />
        </div>
        )}

        {/* Lag Winner */}
        <div style={{ textAlign: 'center' }}>
          <label style={{ display: 'block', fontSize: '16px', fontWeight: '600', marginBottom: '12px' }}>
            Select Lag Winner
          </label>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
            <button
              onClick={() => setLagWinner('player1')}
              style={{
                flex: 1,
                padding: '14px',
                fontSize: '16px',
                fontWeight: '600',
                borderRadius: '8px',
                border: lagWinner === 'player1' ? '2px solid #10b981' : '2px solid #374151',
                backgroundColor: lagWinner === 'player1' ? '#10b981' : 'white',
                color: lagWinner === 'player1' ? 'white' : '#111',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              {p1Name || 'Player 1'}
            </button>
            <button
              onClick={() => setLagWinner('player2')}
              style={{
                flex: 1,
                padding: '14px',
                fontSize: '16px',
                fontWeight: '600',
                borderRadius: '8px',
                border: lagWinner === 'player2' ? '2px solid #10b981' : '2px solid #374151',
                backgroundColor: lagWinner === 'player2' ? '#10b981' : 'white',
                color: lagWinner === 'player2' ? 'white' : '#111',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              {p2Name || 'Player 2'}
            </button>
          </div>
        </div>

        {/* Race To */}
        <div style={{ textAlign: 'center' }}>
          <label style={{ display: 'block', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
            Enter Race to No:
          </label>
          <input
            type="number"
            value={raceTo}
            onChange={(e) => setRaceTo(e.target.value)}
            placeholder="5"
            style={{
              width: '100%',
              padding: '16px',
              fontSize: '18px',
              borderRadius: '8px',
              border: !raceTo ? '2px solid #ef4444' : 'none',
              backgroundColor: 'white',
              color: '#111',
              boxSizing: 'border-box',
            }}
          />
        </div>

        {/* Start Button */}
        <button
          onClick={handleStartMatch}
          disabled={!isValid}
          style={{
            width: '100%',
            padding: '18px',
            fontSize: '20px',
            fontWeight: '700',
            borderRadius: '10px',
            border: 'none',
            backgroundColor: isValid ? '#10b981' : '#374151',
            color: isValid ? 'white' : '#6b7280',
            cursor: isValid ? 'pointer' : 'not-allowed',
            marginTop: '8px',
            transition: 'all 0.2s ease',
          }}
        >
          🎱 Start Match
        </button>

        {/* Back Button */}
        <button
          onClick={() => navigate('/')}
          style={{
            width: '100%',
            padding: '14px',
            fontSize: '16px',
            fontWeight: '500',
            borderRadius: '10px',
            border: '1px solid #374151',
            backgroundColor: 'transparent',
            color: '#9ca3af',
            cursor: 'pointer',
          }}
        >
          ← Back
        </button>

      </div>
    </div>
  );
}

export default ManualMatchSetup;